import { useCallback } from 'react';

import { mealImageToDisplay } from 'helpers/mealDisplay';
import { EXPRESSPLUS_SATURATION_DYNAMIC, EXPRESSPLUS_SATURATION_STATIC } from 'lib/constants';

import useFetchExperimentAssignment from './useFetchExperimentAssignment';

const useMealImageResolver = () => {
  const { isVariant: isInExpressPlusSaturationDynamicExperiment } = useFetchExperimentAssignment(
    EXPRESSPLUS_SATURATION_DYNAMIC
  );
  const { isVariant: isInExpressPlusSaturationStaticExperiment } = useFetchExperimentAssignment(
    EXPRESSPLUS_SATURATION_STATIC
  );

  const isInExpressPlusSaturationExperimentVariant =
    isInExpressPlusSaturationDynamicExperiment || isInExpressPlusSaturationStaticExperiment;

  return useCallback(
    meal => mealImageToDisplay(meal, isInExpressPlusSaturationExperimentVariant),
    [isInExpressPlusSaturationExperimentVariant]
  );
};

export default useMealImageResolver;
